import React, { lazy, Suspense } from 'react';
import Routes from 'routes/Routes';
import 'styles/main.scss';
import 'styles/tailwind/output.css';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import store from 'state/store/store';
import queryClient from 'lib/queryClient';
import Alert from 'components/Alert/Alert';
import createFirebaseApp from 'helpers/firebaseSetup';
import AlertModal from 'components/AlertModal/AlertModal';

const isDevelopment = process.env.NODE_ENV !== 'production';

// lazy so the devtools land in their own chunk and never load in production
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then(module => ({
    default: module.ReactQueryDevtools
  }))
);

function App() {
  createFirebaseApp();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Routes />
        <Alert />
        <AlertModal />
      </Provider>
      {isDevelopment && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  );
}

export default App;
